import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function PortfolioUpdate() {
  const navigate = useNavigate();
  const { portfolio_id } = useParams();
  const [imageFile, setImageFile] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [formData, setFormData] = useState({
    portfolio_id: "",
    title: "",
    sequence: "",
    name: "",
    description: "",
    category: "",
    image: "",
    url: "",
    isactive: false,
  });

  useEffect(() => {
    if (portfolio_id) {
      callApiPortfolioList();
    }
  }, [portfolio_id]);

  const callApiPortfolioList = async () => {
    try {
      console.log("Calling API with portfolio_id:", portfolio_id);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}portfolio/getPortfolioFromID/${portfolio_id}`
      );
      console.log("API response:", response.data);
      setFormData(response.data);
    } catch (err) {
      console.error("API call error:", err);
      toast.error("Failed to fetch portfolio data", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value, sequence, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };

  const callApiUpdatePortfolio = async () => {
    try {
      const data = new FormData();
      data.append("title", formData.title);
      data.append("name", formData.name);
      data.append("description", formData.description);
      data.append("category", formData.category);
      data.append("isactive", formData.isactive);
      data.append("sequence", formData.sequence);

      // Append image file if selected, otherwise append the old image URL
      if (imageFile) {
        data.append("image", imageFile);
      } else {
        data.append("image", formData.image || ""); // Ensure empty string if no image URL
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}portfolio/updatePortfolio/${formData.portfolio_id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("API response:", response.data);

      toast.success("Portfolio updated successfully.", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
      setTimeout(() => {
        navigate("/portfolioList");
      }, 2000);
    } catch (err) {
      console.error("Failed to update portfolio:", err);
      toast.error("Failed to update portfolio", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  };

  const handleConfirmUpdate = () => {
    setShowConfirmModal(false);
    callApiUpdatePortfolio();
  };

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Update Portfolio
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>

              {/* Row 1: Portfolio ID & Title */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="portfolio_id">
                  <Form.Label>Portfolio ID:</Form.Label>
                  <Form.Control
                    type="text"
                    name="portfolio_id"
                    value={formData.portfolio_id}
                    disabled
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="title">
                  <Form.Label>Title:</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder="Title"
                  />
                </Form.Group>
              </Row>

              {/* Row 2: Name & Category */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="name">
                  <Form.Label>Name:</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name"
                    disabled
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="category">
                  <Form.Label>Category:</Form.Label>
                  <Form.Control
                    type="text"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    placeholder="Category"
                  />
                </Form.Group>
              </Row>

              {/* Description */}
              <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description:</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Description"
                />
              </Form.Group>

              {/* Row 3: URL & Sequence */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="url">
                  <Form.Label>URL:</Form.Label>
                  <Form.Control
                    type="text"
                    name="url"
                    value={formData.url}
                    onChange={handleChange}
                    placeholder="Image URL"
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="sequence">
                  <Form.Label>Sequence:</Form.Label>
                  <Form.Control
                    type="number"
                    name="sequence"
                    value={formData.sequence}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Row>

              {/* Image Upload */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="imageUpload">
                  <Form.Label>Image:</Form.Label>
                  <Form.Control
                    type="file"
                    name="image"
                    onChange={handleFileChange}
                  />
                </Form.Group>
                <Col>
                  {formData.image && (
                    <div className="image-preview-container">
                      <Form.Label>Current Image:</Form.Label>
                      <div>
                        <img
                          src={formData.image.startsWith('http') ? formData.image : `${process.env.REACT_APP_API_URL}${formData.image.replace(/\\/g, '/')}`}
                          alt="Current"
                          loading="lazy"
                          className="image-preview"
                        />
                        <span className="image-preview-label">Current image</span>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>

              {/* Toggle Switch for Is Active */}
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  name="isactive"
                  checked={formData.isactive}
                  onChange={handleChange}
                />
                <span className="toggle-switch-label">Is Active</span>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-primary">
                  Update Portfolio
                </button>
                <Link to="/portfolioList" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <ToastContainer />

      {/* Update Confirmation Modal */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update this portfolio?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
